import { CLINICAL_BASE_PATH } from '../constants';

export const BASE_QC_METRICS_PATH = `${CLINICAL_BASE_PATH}/qc_metrics`;

export const QC_METRICS_BATCHES_PATH = `${BASE_QC_METRICS_PATH}/batches`;
export const QC_METRICS_BATCH_PATH = `${BASE_QC_METRICS_PATH}/batch/:batchLabel`;
